module.exports = __webpack_public_path__ + "static/media/emBreve.b9c156b6.svg";